import { Channel } from '@/types/channel';

/**
 * Message also has a push channel, which isn't rendered anywhere at this
 * time.
 */
export const DISPLAYABLE_CHANNELS = [Channel.SMS, Channel.EMAIL, Channel.VOICE, Channel.CHAT];

export const DISPLAYED_CHANNELS = DISPLAYABLE_CHANNELS.join(',');
